/* eslint-disable  */
import UseAxios from '../../../../Api/http/http';
import { getFormValue, setSaveForLater, saveUploadedFiles, deleteUploadedFiles } from '../../../../Api/request/dealDashboard';
import questions from './sales_to_ce_transitionform_data.json';
import { DEAL_TRANSITION_FORM } from '../../../../Constants/strings';

export const fetchFormValues = async (dealId, setApiData, setPrefilledValues, setUploadedFiles, setQuestionList, setFilteredQuestions, setSavedQuestions, reset, setAnsweredQuestions, updateOfferingAppOptions) => {
    UseAxios(getFormValue(dealId))
      .then((response) => {
        const apiData = response?.data;
        setApiData(response?.data?.data?.masterData);

        const clientOptions = apiData?.data?.allClients?.map((client) => ({
          id: client.client_id,
          name: client.client_name,
        })) || [];

        const masterDataMapping = {
          4: apiData.data.masterData.dealTypes,
          8: apiData.data.masterData.dealImplementation,
          9: apiData.data.masterData.dealEnvironment,
          10: apiData.data.masterData.dealSector,
          11: apiData.data.masterData.dealVerticals,
          12: apiData.data.masterData.dealLeadingVertical,
          13: apiData.data.masterData.dealAppMod,
          14: apiData.data.masterData.dealProjectType,
          15: apiData.data.masterData.dealCrossVertical,
          16: apiData.data.masterData.dealKind,
          17: apiData.data.masterData.dealOfferingData,
          18: apiData.data.masterData.dealWorkload,
          19: apiData.data.masterData.dealInfraMod,
          20: apiData.data.masterData.dealOfferingInfra,
          21: apiData.data.masterData.dealInfrastructure,
          24: apiData.data.masterData.dealBoolean,
          27: apiData.data.masterData.dealFunding,
          29: apiData.data.masterData.dealEngagementType,
          30: apiData.data.masterData.dealBoolean,
          34: apiData.data.masterData.dealConstraints,
        };

        const mapOptions = (questionId) => {
          return masterDataMapping[questionId]
            ? masterDataMapping[questionId].map((item) => ({
                id: item.id,
                name: item.name,
              }))
            : [];
        };
        
        const processSubQuestion = (subQuestion) => ({
          ...subQuestion,
          options: mapOptions(subQuestion.id),
          subQuestions: subQuestion.subQuestions ? updateSubQuestions(subQuestion.subQuestions) : [],
        });
        
        const updateSubQuestions = (subQuestions) => subQuestions.map(processSubQuestion);
        


        const updatedQuestions = questions.map((question) => {
          if (masterDataMapping[question.id]) {
            question = {
              ...question,
              options: masterDataMapping[question.id].map((item) => ({
                id: item.id,
                name: item.name,
              })),
            };
          }
          if (question.registerName === "customer_name") {
            question = {
              ...question,
              type: "dropdown",
              options: clientOptions,
            };
          }

          if (question.subQuestions) {
            question.subQuestions = updateSubQuestions(question.subQuestions);
          }

          return question;
        });
        setQuestionList(updatedQuestions);
        setFilteredQuestions(updatedQuestions);

        if (response?.data?.data?.existingDeal) {
          const { form_submitted, ...formData } = response.data.data.existingDeal;
          const saveForLater = response?.data?.data?.dealTransitionSaveLaterData?.[0] || {};

          if (!form_submitted) {
            let answeredCount = 0;
            const prefilledValues = {};
            const savedStatus = {};

            const processFileUpload = (registerName, id) => {
              const uploadedFileData = formData[registerName];
              if (uploadedFileData && Array.isArray(uploadedFileData)) {
                const processedFiles = uploadedFileData.map(file => ({ name: file.split('/').pop() }));
                setUploadedFiles(prevFiles => ({ ...prevFiles, [id]: processedFiles }));
              }
            };
            
            const isOtherOptionSelected = (registerName, id) => {
              const otherOption = updatedQuestions.find(q => q.id === id)?.options?.find(opt => opt.name === "Other");
              return otherOption && Array.isArray(formData[registerName]) &&
                formData[registerName].map(String).includes(String(otherOption.id));
            };
            
            const handleSubQuestions = (subQuestions) => {
              subQuestions.forEach(({ conditional, id: subId, registerName: subRegisterName }) => {
                if (conditional) {
                  const { questionId, showFor } = conditional;
                  if (prefilledValues[`question${questionId}`] &&
                    showFor.includes(prefilledValues[`question${questionId}`].toString())) {
                    prefilledValues[`question${subId}`] = formData[subRegisterName];
                  }
                }
              });
            };
            
            const isMandatoryQuestion = (question, readOnly) => question.includes('*') && !readOnly;
            
            const isQuestionAnswered = (type, registerName) => {
              if (type === 'checkbox' || type === 'radio') {
                return Array.isArray(formData[registerName]) && formData[registerName].length > 0 && 
                       (type !== 'radio' || formData[registerName][0] !== '');
              }
              if (type === 'Other') {
                return Boolean(formData[`${registerName}_custom_data`]);
              }
              return formData[registerName] !== null && formData[registerName] !== '';
            };
            
            questions.forEach(({ registerName, id, type, question, readOnly, subQuestions }) => {
              if (formData[registerName] === undefined) return;
            
              if (registerName in saveForLater) {
                savedStatus[id] = { isSaved: saveForLater[registerName] };
              }
            
              if (type === 'file') {
                processFileUpload(registerName, id);
              } else {
                prefilledValues[`question${id}`] = formData[registerName];
            
                if (isOtherOptionSelected(registerName, id)) {
                  const customDataKey = registerName === 'deal_type_id' ? 'deal_custom_type' : `${registerName.replace('_id', '')}_custom_data`;
                  if (formData[customDataKey]) {
                    prefilledValues[`question${id}_other`] = formData[customDataKey];
                  }
                }
              }
            
              if (subQuestions?.length > 0) {
                handleSubQuestions(subQuestions);
              }
            
              if (isMandatoryQuestion(question, readOnly) && isQuestionAnswered(type, registerName)) {
                answeredCount++;
              }
            });
            
            setSavedQuestions(savedStatus);

            const dealVerticalValue = prefilledValues[`question11`];
            if (dealVerticalValue) {
              updateOfferingAppOptions(dealVerticalValue, apiData.data.masterData);
            }
            setPrefilledValues(prefilledValues);
            reset(prefilledValues);
            setAnsweredQuestions(answeredCount);
          }
        }
      })

      .catch((error) => {
        console.error(error);
      });
  };

  export const onSaveForLater = async ({
    questionId,
    conditional,
    dealId,
    stateHandlers,
    snackbarHandlers,
  }) => {
    const { savedQuestions, setSavedQuestions, setQuestionList, questions } = stateHandlers;
    const { snackbarOpen, setSnackbarMessage, setSeverity } = snackbarHandlers;
  
    const isCurrentlySaved = savedQuestions[questionId]?.isSaved;
  
    setSavedQuestions((prevSavedQuestions) => ({
      ...prevSavedQuestions,
      [questionId]: { isSaved: !isCurrentlySaved, condition: conditional || null },
    }));
  
    setQuestionList((prevQuestions) =>
      prevQuestions.map((q) => (q.id === questionId ? { ...q, saveForLater: !isCurrentlySaved } : q))
    );
  
    const updatedSavedQuestions = {
      ...savedQuestions,
      [questionId]: { isSaved: !isCurrentlySaved, condition: conditional || null },
    };
  
    const requestBody = {
      deal_id: dealId,
      deal_transition_details_id: null,
      ...Object.entries(updatedSavedQuestions).reduce((acc, [id, { isSaved }]) => {
        const question = questions.find((q) => q.id === Number(id));
        if (question) acc[question.registerName] = isSaved || false;
        return acc;
      }, {}),
    };
  
    try {
      await UseAxios(setSaveForLater(requestBody));
      snackbarOpen();
      setSnackbarMessage(isCurrentlySaved ? DEAL_TRANSITION_FORM.QUESTION_REMOVED : DEAL_TRANSITION_FORM.QUESTION_SAVED_FOR_LATER);
      setSeverity("success");
    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  export const onShowSavedQuestions = async (dealId, setFilteredQuestions, setShowSavedQuestions, setShowAllQuestions, setCurrentPage, questionList) => {
    setShowSavedQuestions((prev) => !prev);
    setShowAllQuestions((prev) => !prev);
    setCurrentPage(1);
  
    try {
      const response = await UseAxios(getFormValue(dealId));
      const { dealTransitionSaveLaterData } = response.data.data;
  
      if (!dealTransitionSaveLaterData || dealTransitionSaveLaterData.length === 0) {
        setFilteredQuestions([]);
        return;
      }
  
      const updatedQuestions = questionList.filter((q) => {
        return dealTransitionSaveLaterData.some((item) => item[q.registerName] === true);
      });
  
      setFilteredQuestions(updatedQuestions);
    } catch (error) {
      console.error("Error fetching saved questions:", error);
    }
  };
  
  export const onFileUpload = (event, questionId, setUploadedFiles, setSnackbarMessage, setSeverity, snackbarOpen, MAX_FILE_SIZE) => {
    const files = Array.from(event.target.files);
    const validFiles = [];
    const oversizedFiles = [];
    const invalidFiles = [];

    const allowedExtensions = [
      'pdf', 'xls', 'xlsx', 'csv', 'jpg', 'jpeg', 'png',
      'doc', 'docx', 'mpeg', 'html', 'zip', 'avi', 'ico'
    ];

   files.forEach((file) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      invalidFiles.push(file.name);
    } else if (file.size > MAX_FILE_SIZE) {
      oversizedFiles.push(file.name);
    } else {
      validFiles.push(file);
    }
  });

  if (invalidFiles.length > 0) {
    const allowedExtensionsText = allowedExtensions.map(ext => `.${ext}`).join(', ');
    setSnackbarMessage(`Invalid file type. Only ${allowedExtensionsText} files are allowed.`);
    setSeverity("error");
    snackbarOpen();
  }
  
    if (oversizedFiles.length > 0) {
      setSnackbarMessage(`File size should be less than or equal to 1 MB`);
      setSeverity("error");
      snackbarOpen();
    }
  
    setUploadedFiles((prevFiles) => {
      const existingFiles = prevFiles[questionId] || [];
      if (existingFiles.length + validFiles.length > 10) {
        setSnackbarMessage("You can upload a maximum of 10 files per question.");
        setSeverity("error");
        snackbarOpen();
        return prevFiles;
      }
  
      return {
        ...prevFiles,
        [questionId]: [...existingFiles, ...validFiles],
      };
    });
  };
  
  export const onSaveUploadFiles = async (dealId, uploadedFiles) => {
    const formData = new FormData();
    formData.append("deal_id", dealId);
  
    Object.keys(uploadedFiles).forEach((questionId) => {
      uploadedFiles[questionId].forEach((file) => {
        formData.append("files", file);
      });
    });
  
    try {
      const response = await UseAxios(saveUploadedFiles(formData));
      return response?.status === 200;
    } catch (error) {
      console.error("Error uploading files:", error);
      return false;
    }
  };

  export const onRemoveFile = async ({
    questionId,
    fileIndex,
    uploadedFiles,
    setUploadedFiles,
    dealId,
    snackbarHandlers
  }) => {
    const { setSnackbarMessage, setSeverity, snackbarOpen } = snackbarHandlers;
    const fileToRemove = uploadedFiles[questionId]?.[fileIndex];
    if (!fileToRemove) return;
  
    const requestBody = {
      file_name: `deal-transition/${dealId}/${fileToRemove.name}`,
      deal_id: dealId,
    };
  
    try {
      const response = await UseAxios(deleteUploadedFiles(requestBody));
      if (response) {
        setUploadedFiles((prevFiles) => {
          const updatedFiles = [...prevFiles[questionId]];
          updatedFiles.splice(fileIndex, 1);
          return { ...prevFiles, [questionId]: updatedFiles.length > 0 ? updatedFiles : [] };
        });
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      setSnackbarMessage("Error deleting file. Please try again.");
      setSeverity("error");
      snackbarOpen();
    }
  };
